export type DownloadResponse = { blob: Blob; fileName: string };

export function downloadFileName(disposition: string | null, contentType: string | null): string {
    const encoded = disposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
    let name = disposition?.match(/filename="([^"]+)"|filename=([^;]+)/i)?.slice(1).find(Boolean);
    if (encoded) {
        try { name = decodeURIComponent(encoded); } catch { /* Fall back to plain filename. */ }
    }
    // Keep the suggested name a leaf, even if a proxy supplies a malformed header.
    return name?.trim().split(/[\\/]/).pop()?.replace(/[\x00-\x1f]/g, '')
        || (contentType?.includes('application/zip') ? 'download.zip' : 'download');
}

export async function readDownloadResponse(response: Response): Promise<DownloadResponse | { message: string }> {
    if (!response.ok) {
        try { return await response.json(); }
        catch { return { message: `Download failed (${response.status}).` }; }
    }
    return {
        blob: await response.blob(),
        fileName: downloadFileName(response.headers.get('Content-Disposition'), response.headers.get('Content-Type'))
    };
}
